import React from "react";
import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const decorator = (element, fontSizeDecoration) => {
  const { unit, value } = fontSizeDecoration.fontSizeData || {};
  return /* @__PURE__ */ React.createElement("span", { key: `fontsize-${element.key}`, style: { fontSize: `${value}${unit.toLowerCase()}` } }, element);
};
const FontSizeDecorator = {
  rule: (node) => !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.FONT_SIZE),
  decorate: ({ element, node }) => {
    const fontSizeDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.FONT_SIZE
    );
    return decorator(element, fontSizeDecoration);
  }
};
var viewer_default = FontSizeDecorator;
export {
  viewer_default as default
};
//# sourceMappingURL=viewer.js.map
